import { useState, useRef } from 'react';
import { Upload, X, Loader2 } from 'lucide-react';
import { uploadImage } from '@/lib/storage';
export default function ImageUpload({ value, onChange, onRemove, className }) {
    const [uploading, setUploading] = useState(false);
    const [dragOver, setDragOver] = useState(false);
    const fileInputRef = useRef(null);
    const handleFileSelect = async (file) => {
        if (!file.type.startsWith('image/')) {
            alert('画像ファイルを選択してください。');
            return;
        }
        if (file.size > 5 * 1024 * 1024) { // 5MB limit
            alert('ファイルサイズは5MB以下にしてください。');
            return;
        }
        setUploading(true);
        try {
            const url = await uploadImage(file);
            if (url) {
                onChange(url);
            }
            else {
                alert('画像のアップロードに失敗しました。');
            }
        }
        catch (error) {
            console.error('Upload error:', error);
            alert('画像のアップロードに失敗しました。');
        }
        finally {
            setUploading(false);
        }
    };
    const handleFileInputChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            handleFileSelect(file);
        }
    };
    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const file = e.dataTransfer.files[0];
        if (file) {
            handleFileSelect(file);
        }
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOver(true);
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragOver(false);
    };
    const handleRemove = async () => {
        if (value) {
            // Optionally delete from storage
            // await deleteImage(value);
            if (onRemove) {
                onRemove();
            }
            else {
                onChange('');
            }
        }
    };
    const openFileDialog = () => {
        fileInputRef.current?.click();
    };
    return (<div className={className}>
      <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileInputChange} className="hidden"/>

      {value ? (<div className="relative">
          <img src={value} alt="Uploaded image" className="w-full h-48 object-cover rounded-lg border border-gray-300"/>
          <button type="button" onClick={handleRemove} className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors">
            <X size={16}/>
          </button>
        </div>) : (<div onDrop={handleDrop} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onClick={openFileDialog} className={`
            border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors
            ${dragOver ? 'border-skyblue bg-skyblue/5' : 'border-gray-300 hover:border-gray-400'}
            ${uploading ? 'pointer-events-none opacity-50' : ''}
          `}>
          {uploading ? (<div className="flex flex-col items-center">
              <Loader2 className="w-8 h-8 text-skyblue animate-spin mb-2"/>
              <p className="text-sm text-gray-600">アップロード中...</p>
            </div>) : (<div className="flex flex-col items-center">
              <Upload className="w-8 h-8 text-gray-400 mb-2"/>
              <p className="text-sm text-gray-600 mb-1">
                画像をドラッグ&ドロップまたはクリックして選択
              </p>
              <p className="text-xs text-gray-500">
                JPG, PNG, GIF (最大5MB)
              </p>
            </div>)}
        </div>)}
    </div>);
}
